<template>
  <div class="main">
    <div style="padding-bottom: 15px; text-align: center; width: 800px; display: none;">
        <span style="font-size: 25px">
          {{formTitle}}
        </span>
    </div>
    <div class="main2" v-if="type=='edit'">
      <el-form ref="form" :model="form" :rules="rules" label-width="80px">
        <el-row>
					<el-col :span="12">
						<el-form-item label="标题" prop="标题" size="mini">
						  <el-input v-model="form.标题" ref="标题"></el-input>
							
						</el-form-item>
					</el-col>
					<el-col :span="3">
						<el-form-item label="启用" prop="启用" size="mini" class="demo">
						  <el-switch
						    v-model="form.启用"
								active-value="1"
								inactive-value="0"
						    active-color="#13ce66"
						    inactive-color="#cccccc">
						  </el-switch>
						</el-form-item>
						
					</el-col>
					<el-col :span="3">
						<el-form-item label="带视频" prop="带视频" size="mini" class="demo">
						  <el-switch
						    v-model="form.带视频"
								active-value="1"
								inactive-value="0"
						    active-color="#13ce66"
						    inactive-color="#cccccc">
						  </el-switch>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						
						<el-button type="primary" size="mini" @click="openDialog($event)" style="margin-left: 10px;">锚点管理</el-button>
					</el-col>
				</el-row>
				<el-row>
        	<el-col :span="12">
        		<el-form-item label="备注" prop="备注" size="mini">
        		  <el-input v-model="form.备注" ref="备注"></el-input>
        		</el-form-item>
        	</el-col>
        	<el-col :span="12">
        		<el-form-item label="编辑人备注" prop="编辑人备注" size="mini" label-width="100px">
        		  <el-input v-model="form.编辑人备注" ref="编辑人备注"></el-input>
        		</el-form-item>
        	</el-col>
        	
        </el-row>
        
        <el-form-item label="内容" prop="内容" style="text-align: left;" class="demo">
          <!-- <vue-html5-editor :content="form.内容" @change="updateData" :height="500" :auto-height="false" :show-module-name="false"></vue-html5-editor> -->
					<TinymceEditorVue v-model="form.内容" :anchorList="anchorList" :toolbar="toolbar" :key="UUID"></TinymceEditorVue>
        </el-form-item>
        
				<el-row>
          <div style="text-align: center;">
          	<el-button ref="sendButton" type="primary" size="mini" @click="submitForm('form')" >{{sendButtonValue}}</el-button>
          	<el-button ref="sendButton2" type="warning" size="mini" @click="close('form')">取消</el-button>
          	
          </div>
        </el-row>
      </el-form>
    </div>
		<div v-else class="view">
			<div class="title">{{form.标题}}</div>
			<div class="info">
				<span class="author">{{form.创建人}}</span>
				<span class="created">{{form.创建时间}}</span>
			</div>
			<div class="content">
				<div v-html="form.内容"></div>
			</div>
		</div>
		<el-dialog title="锚点管理" :visible.sync="dialogVisible" :close-on-click-modal="false" id="newDialog2" ref="dialogRef2">
			<AnchorList :MainID="id" @close="closeDialog" @change="getAnchorList" v-if="dialogVisible"></AnchorList>
		</el-dialog>
  </div>
</template>

<script>
  import * as util from "@/utils/util.js"
	import TinymceEditorVue from "../components/TinymceEditor.vue";
	import AnchorList from "./AnchorList.vue";
	
	export default {
    data() {
      return {
        form: {
          AutoID: '0',
          标题: '',
          内容: '',
					MainID: '',
					AppID: '',
					备注: '',
					编辑人备注: '',
					
        },
				OldValue:"",
        rules: {
          标题: [
            {required: true, message: '请输入帮助标题', trigger: 'blur'}
          ],
					
        },
        sendButtonValue: '保存',
				formTitle: '添加标题',
				type:'',
				id:'0',
				loaded: false,
				anchorList: [],
				toolbar: 'undo redo | fontselect fontsizeselect | formatselect | bold italic underline strikethrough | forecolor backcolor | alignleft aligncenter alignright alignjustify | lineheight | bullist numlist outdent indent | link customAnchor hr lists image media table | code removeformat fullscreen',
				form2: {
					AutoID: '0',
					锚点名称: '',
					锚点ID: '',
					
				},
				rules2: {
				  锚点名称: [
				    {required: true, message: '请输入锚点名称', trigger: 'blur'}
				  ],
					锚点ID: [
					  {required: true, message: '请输入锚点ID', trigger: 'blur'}
					],
					
				},
				dialogVisible: false,
				innerVisible: false,
				UUID: '',
      }
    },
    methods: {
      submitForm(formName) {
				//console.log(this.labelList);
				//return;
        this.$refs[formName].validate(async (valid) => {
          if (valid) {
            //console.log(JSON.stringify(this.form));
            //alert('submit!');
						
						var url="/Handler/WenDang.ashx?mode=edit";
						this.$ajax.post(url,this.form).then((response)=>{
						  //console.log(response.data);
						
						  let value=response.data;
						
						  let errorCode=value.errorCode;
						
						  if(errorCode=="0")
						  {
						    this.$message({
						      type: 'success',
						      message: '保存成功:'
						    });
						    
						    this.$store.dispatch('worktabRemoveNoBack', this.$route.name + '-' + this.$route.params.type);
						    
						    this.$router.push({path: '/webdanglist'});
						  }
						  else
						  {
						    let desc=value.desc;
						    this.$alert('保存失败：' +　desc, '系统提示', {
						      confirmButtonText: '确定',
						      callback: action => {
						    
						      }
						    });
						  }
						
						},function(err){
						  console.log(err);
						});

          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      close(){
      	this.$store.dispatch('worktabRemoveNoBack', this.$route.name + '-' + this.$route.params.type);
      	
      	this.$router.push({path: '/webdanglist'});
      },
      updateData(e){
        //console.log('e:',e);
        this.form.内容 = e;
      
      },
			requestData(){
				let url="/Handler/WenDang.ashx?mode=info";
				this.loaded=false;
				
				let payload={
					AutoID: this.id
				}
				
				this.$ajax.post(url,payload).then(
				  response => {
				    //console.log(response.data);
						let errorCode=response.data.errorCode;
						
						if(errorCode=='0'){
							if(response.data.data.length>0){
								this.form=JSON.parse(JSON.stringify(response.data.data[0]));
								
							}
							else{
								this.$alert('获取失败', '系统提示', {
								  confirmButtonText: '确定',
								  callback: action => {
								
								  }
								});
							}
						}
				    else{
							let desc=value.desc;
							this.$alert('获取失败：' +　desc, '系统提示', {
							  confirmButtonText: '确定',
							  callback: action => {
							
							  }
							});
						}
						
						//console.log(this.sltList);
						setTimeout(()=>{
							this.loaded=true;
						},150);
						
				  },
				  function(err) {
				    console.log(err);
						
				  }
				);
				
			},
			getAnchorList(){
				let url="/Handler/Anchor.ashx?mode=GetAnchorList";
				this.anchorList=[];
				
				let payload={
					MainID: this.id
				}
				
				this.$ajax.post(url,payload).then(
				  response => {
				    //console.log(response.data);
						let errorCode=response.data.errorCode;
						
						if(errorCode=='0'){
							
							for(let item of response.data.data){
								let newItem={
									text: item.锚点名称 || '',
									value: item.锚点ID || '',
								}
								
								this.anchorList.push(newItem);
							}
						}
				    else{
							let desc=value.desc;
							this.$alert('获取失败：' +　desc, '系统提示', {
							  confirmButtonText: '确定',
							  callback: action => {
							
							  }
							});
						}
						
						//console.log(this.sltList);
						setTimeout(()=>{
							this.loaded=true;
						},150);
						
				  },
				  function(err) {
				    console.log(err);
						
				  }
				);
				
			},
			openDialog(event, type){
				this.dialogVisible=true;
				
				let weizhi = util.WeiZhi(event, 400, 600, 0, 0, 1);
				//console.log(weizhi);
				
				let l = weizhi.left;
				let t = weizhi.top;
				
				const el = document.querySelector('#newDialog2');;
				const dragDom = el.querySelector('.el-dialog');
				
				dragDom.style.marginTop = '0px';
				dragDom.style.left = l + 'px';
				dragDom.style.top = t + 'px';
				dragDom.style.width =  '450px';
			},
			closeDialog(){
				this.dialogVisible=false;
				
				this.getAnchorList();
			},
			
    },
    async mounted(){
			//console.log('edit mounted');
			
			this.UUID=util.CreateUUID();
			
			this.id=this.$route.params.id;
			this.type=this.$route.params.type;
			
			this.form.AutoID=this.id;
			this.requestData();
			
			this.getAnchorList();
    },
		activated() {
			//console.log('edit activated');
			
			this.UUID=util.CreateUUID();
			
			this.id=this.$route.params.id;
			this.type=this.$route.params.type;
			
			this.form.AutoID=this.id;
		},
		watch:{
			'$route.params.type'(val){
				if(val){
					this.type=val;
				}
				
			},
			'$route.params.id'(val, oldVal){
				if(val){
					this.id=val;
					this.form.AutoID=this.id;
					this.requestData();
				}
				
			}
		},
		components: { TinymceEditorVue, AnchorList },
		
  }
</script>

<style lang="scss" scoped="scoped">
.sendButton {
	padding-left: 10px;
	padding-right: 10px;
	width: 80px;
}
.main2{
	padding: 10px;
	// width: 800px;
	text-align: left;
}
.view{
	margin: 0 auto;
	width: 1200px;
}
.title{
	height: 50px;
	line-height: 50px;
	font-size: 18px;
	font-weight: bold;
}
.info{
	height: 20px;
	line-height: 20px;
	color: #666666;
	.author{
		margin-right: 20px;;
	}
}
.content{
	padding: 15px;
	text-align: left;
	line-height: 180%;
}
/* 假设编辑器内容渲染在 class 为 editor-content 的容器中 */
.vue-html5-editor img {
	max-width: 600px; /* 确保图片不超过容器宽度 */
	height: auto;    /* 保持宽高比 */
	display: block;  /* 可选，消除底部空隙 */
}
</style>
